module.exports = __webpack_public_path__ + "static/ML_-3de80f1cef6a7a878503595dd2f4a1c8.png";